module.exports = __webpack_public_path__ + "front/img/p2.78cd7301.png";